import GenericFilter from '@/AdminComponent/GenericFilter';
import TRC_FILE_TYPE, { TRC_FILE_TYPE_LABELS } from '@/TRC/constants/trcFileType';

const CONTENT_TYPE_OPTIONS = [
	{ value: TRC_FILE_TYPE.ALL, label: TRC_FILE_TYPE_LABELS.ALL },
	{ value: TRC_FILE_TYPE.VIDEO, label: TRC_FILE_TYPE_LABELS.VIDEO },
	{ value: TRC_FILE_TYPE.PDF, label: TRC_FILE_TYPE_LABELS.PDF }
];

const CONTENT_CONFIG = [
	{
		type: 'select',
		name: 'type',
		label: 'Content Type',
		options: CONTENT_TYPE_OPTIONS,
		grid: { xs: 12, sm: 3 }
	},
	{
		type: 'text',
		name: 'search',
		label: 'Search Content',
		placeholder: 'Enter title or keyword...',
		grid: { xs: 12, sm: 7 }
	}
];

const ContentFilters = ({ filters, setFilters }) => {
	return (
		<GenericFilter
			config={CONTENT_CONFIG}
			filters={filters}
			setFilters={setFilters}
			debounceMs={500}
			syncWithUrl
			showReset
		/>
	);
};

export default ContentFilters;
